import IAddress from "./IAddress";
import Address from "./Address";
import IEntrepreneur from "./IEntrepreneur";

export default class Entrepreneur implements IEntrepreneur {
    constructor(
        public address: IAddress = new Address(),
        public businessId: string = "",
        public representativeFirstName: string = "",
        public representativeLastName: string = "",
        public email: string = "",
        public phone: string = "",
    ) {
    }
}
